import React from "react"
import { Navbar } from "@/components/Navbar"
import { Footer } from "@/components/Footer"
import type { ReactNode } from "react"

export const Layout = ({ children }: { children: ReactNode }) => (
  <>
    <Navbar />
    <main className="min-h-screen bg-background text-foreground">{children}</main>
    <Footer />
  </>
)
